/** Guest-facing lead includes the full two-hour decision window and a buffer. */
export const HOST_RESPONSE_WINDOW_MS = 2 * 60 * 60 * 1000
export const BOOKING_MIN_LEAD_MS = 3 * 60 * 60 * 1000

export function startsTooSoonForHostApproval(startAt: string, nowMs = Date.now()): boolean {
  const startMs = Date.parse(startAt)
  return !Number.isFinite(startMs) || startMs - nowMs < BOOKING_MIN_LEAD_MS
}
